export const SYLPH_COLOR_THRESHOLD = 3;
export const SYLPH_SYMBOL_THRESHOLD = 4;

export const GAME_CONFIG = {
  width: 412,
  height: 915,
  gridSize: 6,
  gridPadding: 16,
  tilePreviewSize: 64,
} as const;

const BIOMES = [
  { ground: 'ground-wetland', name: 'Wetland', particles: [0x4ecdc4, 0x2ab7a5, 0x7edbd3, 0x1a9e8f] },
  { ground: 'ground-forest', name: 'Forest', particles: [0x6bcb77, 0x4a9e55, 0x8fd99a, 0x3d8b48] },
  { ground: 'ground-alpine', name: 'Alpine', particles: [0xb8d4e3, 0x8fb8cc, 0xd4e8f2, 0x7aa8c0] },
  { ground: 'ground-coral', name: 'Coral Coast', particles: [0xe07a5f, 0xc55a3f, 0xf0a08a, 0xd4684a] },
  { ground: 'ground-meadow', name: 'Meadow', particles: [0xdda15e, 0xc4893e, 0xeabb7e, 0xb8773a] },
] as const;

function biomeIndex(level: number): number {
  return Math.floor((level - 1) / 5) % BIOMES.length;
}

export function getRestoredGroundKey(level: number): string {
  return BIOMES[biomeIndex(level)].ground;
}

export function getBiomeDecorKeys(level: number): string[] {
  const biomeNames = ['wetland', 'forest', 'alpine', 'coral', 'meadow'];
  const biome = biomeNames[biomeIndex(level)];
  return [`decor-${biome}-1`, `decor-${biome}-2`, `decor-${biome}-3`];
}

export function getBiomeName(level: number): string {
  return BIOMES[biomeIndex(level)].name;
}

export function getBiomeParticleColors(level: number): readonly number[] {
  return BIOMES[biomeIndex(level)].particles;
}
